import ForgotPassword from "containers/Auth/ForgotPassword/ForgotPassword";
import Head from "next/head";
import React from "react";
import {useLocales} from "@libs";

const ForgotPasswordPage = () => {
    const {currentShortLocale} = useLocales();

    return (
        <>
            <Head>
                <title> Vinglet - Recovering Password </title>
            </Head>
            <ForgotPassword currentShortLocale={currentShortLocale}/>
        </>
    );
};

export default ForgotPasswordPage;
